import initializeComponent from 'Shared/react-initialize';
import { BreadCrumbs, BreadcrumbData } from '@ifixit/carpenter-breadcrumbs/Breadcrumbs';

const NavBreadcrumbs = ({ breadcrumbs }: { breadcrumbs: BreadcrumbData[] }) => {
   if (!breadcrumbs) {
      return null;
   }

   return (
      <div className="flex h-full w-full pl-4">
         <BreadCrumbs breadCrumbs={breadcrumbs} />
      </div>
   );
};

initializeComponent('NavBreadcrumbs', NavBreadcrumbs);
